"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext, useMemo } from "react";
import { useSearchParam } from "#/shared/hooks/useSearchParam";
import { PLAYGROUND_VIEW_PARAM_OPTIONS, type PlaygroundView, type PlaygroundViewParam } from "../model/playgroundView";
type PlaygroundViewContextValue = PlaygroundViewParam;
const PlaygroundViewContext = createContext<PlaygroundViewContextValue | null>(null);
export type PlaygroundViewProviderProps = {
  children: ReactNode;
};

/**
 * Provides a single source of truth for the playground view param.
 * When setView is called, all consumers see the update immediately (no router delay).
 * Use when multiple components need to stay in sync with the view param.
 */
export const PlaygroundViewProvider: React.FC<PlaygroundViewProviderProps> = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const [view, setView] = useSearchParam("view", PLAYGROUND_VIEW_PARAM_OPTIONS);
  let t1;
  if ($[0] !== setView || $[1] !== view) {
    t1 = {
      view,
      setView
    };
    $[0] = setView;
    $[1] = view;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const value = t1;
  let t2;
  if ($[3] !== children || $[4] !== value) {
    t2 = <PlaygroundViewContext.Provider value={value}>{children}</PlaygroundViewContext.Provider>;
    $[3] = children;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const usePlaygroundViewContext = () => {
  return useContext(PlaygroundViewContext);
};